<template>
  <div :class="[containerClass, 'banner-container']" ref="bannerContainer">
    <div class="banner-wrap" :style="{ transform: `translateX(${-1 * itemWidth * (currentBannerIndex)}px)` }">
      <div
          v-for="(item, index) in items"
          :key="index"
          :style="{ width: itemWidth + 'px' }"
          :class="['banner-item', `banner-item-${index + 1}`]"
      >
        <slot :item="item" :index="index"></slot>
      </div>
    </div>

    <div class="indicators" v-if="showIndicators" :style="indicatorStyle">
      <span
          v-for="(indicator, indicatorIndex) in items"
          :key="indicatorIndex"
          @click="goToBanner(indicatorIndex)"
          :class="{ active: currentBannerIndex === indicatorIndex }"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SwipeBanner",
  props: {
    containerClass: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    },
    showIndicators: {
      type: Boolean,
      default: true,
    },
    touchEnabled: {
      type: Boolean,
      default: true,
    },
    indicatorPosition: {
      type: String,
      default: 'top-right',
    },
    autoSwipeInterval: {
      type: Number,
      default: 6000,
    },
  },
  data() {
    return {
      currentBannerIndex: 0,
      autoSwipeTimer: null,
      touchStartX: 0,
      touchEndX: 0,
      itemWidth: 0
    };
  },
  computed: {
    indicatorStyle() {
      const style = {};

      if (this.indicatorPosition === 'top-right') {
        style.top = '40px';
        style.right = '40px';
      }

      return style;
    },
  },
  methods: {
    goToBanner(index) {
      this.currentBannerIndex = index;
      this.resetAutoSwipeTimer();
    },

    resetAutoSwipeTimer() {
      if (this.autoSwipeTimer) {
        clearInterval(this.autoSwipeTimer);
      }
      this.autoSwipeTimer = setInterval(() => {
        this.currentBannerIndex = (this.currentBannerIndex + 1) % this.items.length;
      }, this.autoSwipeInterval);
    },

    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
    },

    handleTouchEnd(event) {
      this.touchEndX = event.changedTouches[0].clientX;
      const deltaX = this.touchEndX - this.touchStartX;

      if (deltaX > 0) {
        // Swipe right
        this.currentBannerIndex = (this.currentBannerIndex - 1 + this.items.length) % this.items.length;
      } else if (deltaX < 0) {
        // Swipe left
        this.currentBannerIndex = (this.currentBannerIndex + 1) % this.items.length;
      }

      this.resetAutoSwipeTimer();
    },

    updateItemWidth() {
      this.itemWidth = this.$refs.bannerContainer.clientWidth;
    },
  },
  mounted() {
    this.updateItemWidth();
    this.resetAutoSwipeTimer();

    if (this.touchEnabled) {
      document.addEventListener('touchstart', this.handleTouchStart);
      document.addEventListener('touchend', this.handleTouchEnd);
    }

    const resizeObserver = new ResizeObserver(this.updateItemWidth);
    resizeObserver.observe(this.$refs.bannerContainer);
  },
  beforeUnmount() {
    clearInterval(this.autoSwipeTimer);

    if (this.touchEnabled) {
      document.removeEventListener('touchstart', this.handleTouchStart);
      document.removeEventListener('touchend', this.handleTouchEnd);
    }
  },
};
</script>

<style scoped lang="scss">
.banner-container {
  position: relative;
}

.banner-wrap {
  position: relative;
  white-space: nowrap;
  display: flex;
  transition: transform 0.5s ease;
  height: 100%;
}

.banner-item {
  position: relative;
  flex: 0 0 auto;
  box-sizing: border-box;
  margin: 0;
}

.indicators {
  position: absolute;
  display: flex;
  flex-direction: row;
  z-index: 1;
}

.indicators span {
  width: 10px;
  height: 10px;
  margin: 0 3px;
  background-color: #E5E5E5;
  border-radius: 50%;
  cursor: pointer;

  box-shadow: 0px 2px 5px rgb(0 0 0 / 50%);
  -webkit-box-shadow: 0px 2px 5px rgb(0 0 0 / 50%);
  -moz-box-shadow: 0px 2px 5px rgb(0 0 0 / 50%);
}

.indicators span.active {
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);

}
</style>
